import { trackCustomEvent } from 'app/utils/statistics/clientStatistics';
import { toggleEpisodePicker } from 'app/utils/statistics/customEvents';
import React, { useContext } from 'react';
import SvgIcon, { SvgIcons } from 'app/ui-components/SvgIcon/SvgIcon';
import { StyledToggle } from './EpisodePickerButton.styles';
import { VideoPlayerContext } from '../../VideoPlayerContext';

const EpisodePickerButton: React.FC<{
    playedPercentage: number;
}> = ({ playedPercentage }) => {
    const { displayEpisodePicker, setContext } = useContext(VideoPlayerContext);
    const handleClick = () => {
        setContext('displayEpisodePicker', !displayEpisodePicker);
        trackCustomEvent(toggleEpisodePicker(!displayEpisodePicker, playedPercentage));
    };

    if (displayEpisodePicker) {
        return (
            <StyledToggle onClick={handleClick} displayEpisodePicker>
                <span>Dölj avsnitt</span>
            </StyledToggle>
        );
    }

    return (
        <StyledToggle onClick={handleClick}>
            <SvgIcon icon={SvgIcons.PLAYLIST} width={17} />
            <span>Fler avsnitt</span>
        </StyledToggle>
    );
};

export default EpisodePickerButton;
